// How many skeleton rows the admin release notes list should draw on a cold
// load. Global cache — the changelog is one list for the whole product, not
// scoped to a user or an org. See docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const KEY = 'admin_release_notes_count'
const DEFAULT_COUNT = 6

export function getCachedReleaseNotesCount() {
  return getCachedSkeletonCount(KEY, DEFAULT_COUNT)
}

export function setCachedReleaseNotesCount(count) {
  setCachedSkeletonCount(KEY, count)
}
